export const VERIFY_AGE = 'verifyAge';
export const VERIFY_AGE_SET = 'verifyAgeSet';
export const USER = "USER";
export const CREATOR = "CREATOR";

export const defaultProfileBanner =
  "https://juicyhouse-content.s3.us-east-1.amazonaws.com/prod/default/default_profile.jpeg";
export const DEFAULT_FEATURED_PROFILE_BANNER =
  "https://storage.googleapis.com/uxpilot-auth.appspot.com/29614f9fce-4c0f8a3aa19c2604ddeb.png";
export const RED_LOGO = require('../../assets/img/red-logo.png');
export const DEFAULT_USER_AVATAR = require('../../assets/img/default-user.png');
export const PLACEHOLDER_POST_IMAGE = require('../../assets/placeholder/post.png');

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// api timeout constants
export const TIMEOUT_CONFIG = {
  DEFAULT: 10000, // 10 seconds default timeout
  SIGNUP: 60000, // 60 seconds for signup APIs
  MULTIPART_UPLOAD: 60000, // 60 seconds for multipart upload APIs
  CCBILL: 60000, // 60 seconds for CCBill APIs
  FEED: 30000, // 30 seconds for feed APIs
  THUMBNAIL: 60000, // 60 seconds for thumbnail creation APIs
  PDF: 60000, // 60 seconds for earnings PDF APIs
  W9_FORM: 30000, // 30 seconds for W-9 form APIs
  W8_FORM: 30000, // 30 seconds for W-8 form APIs
  PAYOUT_REQUEST: 60000, // 60 seconds for payout request APIs
  SUBSCRIPTION: 60000, // 60 seconds for subscription create APIs
};

export const CONFIG = {
  APP_VERSION: '2.4.1',
  SUPPORT_EMAIL: 'support@juicyhouse.com',
  PRIVACY_EMAIL: 'privacy@juicyhouse.com',
  DMCA_EMAIL: 'dmca@juicyhouse.com',
  INFO_EMAIL: 'info@juicyhouse.com',
  APPEAL_EMAIL: 'appeal@juicyhouse.com',
  COMPLAINT_EMAIL: 'complaint@juicyhouse.com',
  APP_NAME: 'Juicy House',
  LEGAL_LAST_UPDATED_DATE: 'May 8, 2020',
  LEGAL_EFFECTIVE_DATE: 'May 8, 2020',
  LEGAL_LAST_REVISED_DATE: 'May 8, 2020',
  VIOLATION_EMAIL: 'violation@juicyhouse.com',
  PLATFORM_URL: 'https://www.juicyhouse.com',
  W9_FORM_URL: 'https://www.irs.gov/pub/irs-pdf/fw9.pdf',
  CCBILL_URL: 'https://ccbill.com',
  MIN_BALANCE_TO_CASH_OUT: 30,
  MIN_BALANCE_TO_TAX_INFO: 599,
};

export const CONTACT_US_INFO = {
  name: "Prestige International LLC",
  location: "Newark Delaware, United States of America",
  ccbill: "https://support.ccbill.com",
};

export const EXTERNAL_LINKS = {
  CCBILL: 'https://ccbill.com',
  CCBILL_TEXT: "ccbill.com"
};

export const AUTH_TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  USER_TYPE: 'userType',
  USER_ID: 'userId',
  // Matrix credentials (short-lived access token + identifiers)
  MATRIX_ACCESS_TOKEN: 'matrixAccessToken',
  MATRIX_USER_ID: 'matrixUserId',
  MATRIX_DEVICE_ID: 'matrixDeviceId',
  /** Epoch ms when the current Matrix access token was issued / last refreshed. */
  MATRIX_ACCESS_TOKEN_AT: 'matrixAccessTokenAt',
  /** Compact inbox rows so the list can paint while Matrix re-logins after idle. */
  MATRIX_INBOX_SNAPSHOT: 'matrixInboxListSnapshot',
  /** Client-side throttle for PATCH user/login-time (see LoginTimeInitializer, userActions) */
  LOGIN_TIME_LAST_SYNC_AT: 'loginTimeLastSyncAt',
  /** True when the session was created via admin support password login */
  IS_LOGIN_WITH_SUPPORT_PASSWORD: 'isLoginWithSupportPassword',
};

/** Signed URL expiry: backend uses 1h; we reload before expiry so media keeps working after minimize/reopen */
export const SIGNED_URL_REFRESH = {
  /** localStorage key for timestamp when current signed-URL session started */
  STORAGE_KEY: 'signedUrlSessionStart',
  /**
   * localStorage key for when the tab was last hidden.
   * Persisted in localStorage (not sessionStorage) because iOS Safari often clears
   * sessionStorage on long suspend, which would lose the hidden timestamp.
   */
  HIDDEN_AT_KEY: 'signedUrlHiddenAt',
  /** Reload page if user returns after this many minutes (must be < 60 to stay before 1h expiry) */
  RELOAD_AFTER_MINUTES: 55,
  /** RELOAD_AFTER_MINUTES in milliseconds */
  get RELOAD_AFTER_MS() {
    return this.RELOAD_AFTER_MINUTES * 60 * 1000;
  },
};

/**
 * Detects iOS Safari / mobile browser CSS purge after long background.
 * JS/React state can survive while bundled stylesheets are dropped from memory.
 */
export const CSS_HEALTH = {
  PROBE_ELEMENT_ID: 'jh-css-health-probe',
  /** Must match the value set in index.css :root */
  LOADED_VAR: '--jh-css-loaded',
  LOADED_VAR_VALUE: '1',
  /** sessionStorage counter to avoid infinite reload loops in the same tab */
  RELOAD_ATTEMPT_KEY: 'cssHealthReloadAttempts',
  MAX_RELOAD_ATTEMPTS: 2,
};

export const ROLE = {
  ADMIN: 0,
  CREATOR_SUB: 1,  // monthly Creator
  CREATOR_CONTENT: 3, // ppv Creator
  USER: 2,
};

export const ACCOUNT_TYPES = {
  CREATOR: 'creator',
  SUBSCRIBER: 'subscriber'
};

export const USER_ROLE_LABELS = {
  SUBSCRIBER: 'subscriber',
  FOLLOWER: 'follower'
};

export const TOAST_CONFIG = (isDarkMode) => {
  return {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: (isDarkMode ? "dark" : "light")
  };
};

export const USER_TYPE = {
  CREATOR: 'creator',
  USER: 'user',
  ADMIN: 'admin',
  GUEST: 'guest'
};

export const UPLOAD_TYPE = {
  PICTURE: 'picture',
  BANNER: 'banner',
};

export const OFFER_TYPE = {
  FIRST_MONTH: 'first_month',
  FREE_TRIAL: 'free_trial',
};

export const LIMIT_TYPE = {
  FIXED: 'fixed',
  NO_LIMIT: 'no_limit',
};

export const PROMOTION_STATUS = {
  RUNNING: 'running',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const PROMOTION_DISCOUNT_TYPE = {
  PERCENT: 'percent',
  DOLLAR: 'dollar',
};

export const UPLOAD_CONTENT_TYPE = {
  PAID: 'paid',
  FREE: 'free',
};

export const SUBSCRIPTION_PLAN = {
  DEFAULT_PRICE: 9.99,
  MIN_PRICE: 5,
  MAX_PRICE: 300
};

/** Delay before refetching data after subscribe/unsubscribe success. */
export const SUBSCRIPTION_STATUS_REFRESH_DELAY_MS = 1000;

export const CONTENT_PRICING = {
  MIN_PRICE: 3.00,
  MAX_PRICE: 300,
};

export const MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  BUNDLE: 'bundle'
};

export const MATRIX_CONTENT_TYPE = {
  MEDIA: 'media',
  TIP: 'tip',
};

export const TAB_TYPE = {
  FEED: 'feed',
  MEDIA: 'media',
  FREE: 'free'
};

export const PAYMENT_INFO = {
  currencyCode: 890,
  initialPrice: 0,
  initialPeriod: 0,
  extraCharge: 0.25,
  vatRate: 2,
  platformFeePercentage: 20,
};

// Transaction Types
export const TRANSACTION_TYPE = {
  SUBSCRIPTION: 'subscription',
  TIP: 'tip',
  PURCHASE_CONTENT: 'purchase_content',
  MESSAGES_TIP: 'messages_tip',
  WALLET_CREDIT_PURCHASE: 'wallet_credit_purchase',
  MESSAGE_PURCHASE_CONTENT: 'messages_purchase_content',
  VOICE_CALL: 'call_audio',
  VIDEO_CALL: 'call_video',
  CALL_TIP: 'call_tip',
};

export const CALL_PRICING_MODEL_PER_MINUTE = {
  AMOUNT: 10, // $10 per minute
  DURATION: 1 // 1 minute
}

export const CALL_PRICING_MODEL_FLAT_RATE = {
  AMOUNT: 50, // $50
  DURATION: 5, // default flat-rate session length (minutes)
  MIN_DURATION_MINUTES: 5,
  MAX_DURATION_MINUTES: 300,
}

export const PURCHASE_STATE = {
  INITIAL: 0,
  ACTIVE: 1,
  PENDING: 2,
  // EXPIRED: 3,
  EXPIRED: 4,
}

export const CLOUDFLARE_LOCATION = {
  URL: 'https://juicyhouse-content-stg-worker.curtis-e8f.workers.dev',
  ACCESS_CLIENT_ID: 'da0d164c513f484668efc5c3cad11b07.access',
}

export const MESSAGE_READ = {
  SHOW_MORE_TEXT: 'Show more',
  SHOW_LESS_TEXT: 'Show less',
}

export const MIN_VALUE_TIPS = parseFloat(process.env.REACT_APP_TIPS_MIN_VALUE) || 3.33;
export const MAX_VALUE_TIPS = parseFloat(process.env.REACT_APP_TIPS_MAX_VALUE) || 83.33;
export const ADM_TIP_PERCENTAGE = parseFloat(process.env.REACT_APP_TIPS_ADM_PERCENTAGE) || 1.2;
export const DEFAULT_PRESET_AMOUNTS = [8.33, 20.83, 41.67];

/** Recommended OG image dimensions: 1200x630 for link previews (FB/IG), 400x400 min for profile pics */
export const OG_IMAGE_DIMENSIONS = {
  DEFAULT: { width: 1200, height: 630 },
  PROFILE_AVATAR: { width: 400, height: 400 },
};

/** Share card format: logo left, title + description + juicyhouse.com on right. For links not tied to a creator profile. */
export const SOCIAL_SHARING = {
  DEFAULT_OG_IMAGE: "https://s3.us-east-1.wasabisys.com/juicyhouse-content-stg-worker/mobile_logo.png",
  /** Optional: 1200x630 composite image (logo left, text + background right) for exact share preview format */
  SHARE_CARD_OG_IMAGE: null,
  /** Title for generic (non-creator) link previews e.g. juicyhouse.com */
  DEFAULT_OG_TITLE: "Keep 100% on Juicy House 🍑",
  /** Description for generic (non-creator) link previews */
  DEFAULT_OG_DESCRIPTION: "Call. Connect. Get discovered.",
  /** For profile link previews (e.g. juicyhouse.com/username). Replace {username} when rendering server-side meta. */
  PROFILE_OG_TITLE_TEMPLATE: "@{username} wants to talk 🍑 Call or message on Juicy House",
};

export const TIP_TYPE = {
  CONTENT: 'content',
  MESSAGES: 'messages',
};

export const MESSAGES_TIP_DEFAULT_MESSAGE =
  "Here's the tip to lock my call in with you tonight. Can't wait! I have been really excited to talk to you and I have a $5,000 budget for you with this call";

export const MESSAGES_TIP_PREVIEW_LENGTH = 80;

/** Max visible `@handle` length in compact cards/lists before appending `...`. */
export const USERNAME_DISPLAY_MAX_LENGTH = 10;